/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Chip, CircularProgress, debounce } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import HistoryIcon from "@material-ui/icons/History";
import HorizonatlSeprator from "assets/svgs/HorizonatlSeprator";
import NotActiveInCity from "assets/svgs/NotActiveInCity";
import React, { useEffect, useRef, useState } from "react";
import { isUserLoggedIn } from "utils";
import { getLocationSearchResults } from "utils/apiClients";
import { getSearchEventProps, setSearchEventProps } from "utils/commonUtils";
import { SEARCH_MP_EVENTS_PROPS_NAME } from "modules/candidate/profile/constants/mixpanelConstants";
import { POPULAR_CITIES } from "./constants";
import HighlightQuery from "./HighlightQuery";
import { CitySuggestionType } from "./types";

function CitySearchResults({ handleCitySelect, query }) {
	const [filteredResults, setFilteredResults] = useState([]);
	const [loading, setLoading] = useState(false);
	const [showNoLiveCities, setShowNoLiveCities] = useState(false);
	const renderSubText = (citySubText) => {
		if (citySubText?.length > 31) {
			return `${citySubText.substr(0, 31)}...`;
		}
		return citySubText;
	};
	const searchLocation = (queryString) => {
		setLoading(true);
		return getLocationSearchResults(queryString)
			.then((resp: any) => {
				setLoading(false);
				setFilteredResults(resp?.data?.suggestions?.slice(0, 5) || []);
				if (!resp?.data?.suggestions?.length) {
					setShowNoLiveCities(true);
				}
			})
			.catch((e) => {
				console.log(e);
				setLoading(false);
				setFilteredResults([]);
			});
	};

	const debouncedSearch = useRef(debounce(searchLocation, 250));

	useEffect(() => {
		if (query?.trim()?.length > 1) {
			debouncedSearch?.current(query);
		}
	}, [query]);

	const popular = POPULAR_CITIES.map((city: any) => (
		<div
			key={`POPULAR_CITIES_${city?.display_text}`}
			className="flex w-full cursor-pointer flex-row items-center gap-4 px-4 py-[6px] hover:bg-[#EAF8F4]"
			onMouseDown={() => {
				const searchEventObj = getSearchEventProps();
				const obj = {
					[SEARCH_MP_EVENTS_PROPS_NAME.LOCATION_SEARCH_FEATURE_USED]:
						"Preferred Cities",
				};
				const resObj = { ...searchEventObj, ...obj };
				setSearchEventProps(resObj);
				handleCitySelect(city);
			}}
			onClick={() => {
				const searchEventObj = getSearchEventProps();
				const obj = {
					[SEARCH_MP_EVENTS_PROPS_NAME.LOCATION_SEARCH_FEATURE_USED]:
						"Preferred Cities",
				};
				const resObj = { ...searchEventObj, ...obj };
				setSearchEventProps(resObj);
				handleCitySelect(city);
			}}
		>
			<div className="flex h-[45px] w-[45px] items-center justify-center rounded-md bg-[#F4F2F6] p-1">
				<Search color="disabled" />
			</div>
			<div className="w-100 flex flex-col overflow-hidden text-ellipsis whitespace-nowrap">
				<span className="text-[16px]">{city?.display_text}</span>
			</div>
		</div>
	));

	const popularAndRecent = (
		<div className="flex w-full flex-col gap-[24px] py-2 md:py-0">
			{/* {isUserLoggedIn() && recentCities?.length > 0 && (
				<div className="flex flex-col gap-2">
					<p className="m-0 px-4 text-sm font-semibold leading-[20px]">
						Recent searches
					</p>
					<div className="flex flex-row flex-wrap gap-[8px] px-4">
						{recentCities.map((searchOption: any) => (
							<Chip
								icon={<HistoryIcon fontSize="small" />}
								key={`recent_${searchOption?.display_text}`}
								onMouseDown={() => {
									const searchEventObj = getSearchEventProps();
									const obj = {
										[SEARCH_MP_EVENTS_PROPS_NAME.LOCATION_SEARCH_FEATURE_USED]:
											"Recent",
									};
									const resObj = { ...searchEventObj, ...obj };
									setSearchEventProps(resObj);
									handleCitySelect(searchOption);
								}}
								onClick={() => {}}
								label={searchOption?.display_text}
								variant="outlined"
							/>
						))}
					</div>
				</div>
			)} */}
			<div className="flex flex-col">
				<p className="m-0 px-4 text-sm font-semibold leading-[20px]">
					{/* {isUserLoggedIn() ? "Your preferred cities" : "Popular cities"} */}
					Popular Searches
				</p>
				<div id="js-navigation-parent" className="flex flex-col">
					{popular}
				</div>
			</div>
		</div>
	);

	if (query?.trim().length) {
		let filtered: any = filteredResults.map((city: CitySuggestionType) => (
			<div
				key={`filtered${city?.display_text}`}
				className="flex w-full cursor-pointer flex-row items-center gap-4 px-4 py-[6px] hover:bg-[#EAF8F4]"
				onMouseDown={() => {
					const searchEventObj = getSearchEventProps();
					const obj = {
						[SEARCH_MP_EVENTS_PROPS_NAME.LOCATION_SEARCH_FEATURE_USED]:
							"Suggested",
					};
					const resObj = { ...searchEventObj, ...obj };
					setSearchEventProps(resObj);
					handleCitySelect(city);
				}}
				onClick={() => {
					const searchEventObj = getSearchEventProps();
					const obj = {
						[SEARCH_MP_EVENTS_PROPS_NAME.LOCATION_SEARCH_FEATURE_USED]:
							"Suggested",
					};
					const resObj = { ...searchEventObj, ...obj };
					setSearchEventProps(resObj);
					handleCitySelect(city);
				}}
			>
				<div className="flex h-[45px] min-w-[45px] items-center justify-center rounded-md bg-[#F4F2F6] p-1">
					<Search color="disabled" />
				</div>
				<div className="w-full overflow-hidden text-ellipsis whitespace-nowrap text-[#8C8594]">
					<div className="overflow-hidden text-ellipsis text-[16px]">
						<HighlightQuery text={city?.display_text} query={query} />
					</div>
					<div className="text-[14px] ">{renderSubText(city?.sub_text)}</div>
				</div>
			</div>
		));

		let topInfo: any = "";

		let content: any = popular;

		if (filteredResults.length) {
			topInfo = "";
			content = filtered;
		}

		if (loading) {
			topInfo = "";
			content = <CircularProgress />;
			filtered = (
				<div className="mt-2 w-full text-center">
					<CircularProgress />
				</div>
			);
		}
		if (showNoLiveCities) {
			topInfo = (
				<>
					<div className="flex w-full flex-col items-center ">
						<div className="mb-4">
							<NotActiveInCity />
						</div>
						<div className="text-sm font-bold">
							We are not active in this city or area{" "}
						</div>
						<div className="mb-4 text-xs text-[grey]">
							Try searching for other areas or cities
						</div>
						<div className="w-full px-4">
							<HorizonatlSeprator width="100%" />
						</div>
					</div>
					<p className="mb-0 mt-3 px-4 text-sm font-semibold leading-[20px]">
						Popular Searches
					</p>
				</>
			);
		}

		return (
			<div className="flex w-full flex-col py-2 md:py-0">
				{topInfo}
				<div
					id="js-navigation-parent"
					className={`flex flex-col ${
						loading ? "items-center" : "items-start"
					}`}
				>
					{content}
				</div>
			</div>
		);
	}

	return popularAndRecent;
}

export default CitySearchResults;
